export const base_url = "https://wordaddin.educating.ai"